import { useContext, useRef } from 'react';
import { useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom';
import { ScrollToTop } from '@components/ScrollToTop/ScrollToTop';
import { useSelector } from 'react-redux';
import { checkDevice } from '@store/redux/features/mobile/mobileSelectors';
import { Contacts, Documents, Resources, Sidebar, Updates } from './components';

import { AssetContext } from './Asset.query';
import {
  Container,
  Right,
  RightBottom,
  RightMiddle,
  RightTop,
} from './Asset.styles';
import { AssignTag } from './components/Sidebar/components/Tags/components/AssignTag/AssignTag';
import { useAssignTagMutation } from './components/Sidebar/components/Tags/components/AssignTag/AssignTag.hooks';

import { onAssignConfirm } from './Asset.utils';
import { AssetHistory } from './components/AssetHistory/AssetHistory';

export const AssetRaw = () => {
  const { openTagModal, sidebarHeadingHeight } = useContext(AssetContext);
  const { equipmentQuery } = useContext(AssetContext);
  const equipmentTags = equipmentQuery?.data?.tags ?? [];
  const params = useParams<{ equipmentId: string }>();
  const mutation = useAssignTagMutation();
  const queryClient = useQueryClient();
  const viewportRef = useRef<HTMLDivElement | null>(null);
  const { isMobile } = useSelector(checkDevice());

  return (
    <Container data-offsettop={sidebarHeadingHeight.get()} ref={viewportRef}>
      <Sidebar />
      <Right>
        <RightTop>
          <AssetHistory />
        </RightTop>

        <RightMiddle>
          <Resources />
          <Documents />
        </RightMiddle>

        <RightBottom>
          <Updates />
          <Contacts />
        </RightBottom>
      </Right>

      <AssignTag
        activeList={equipmentTags}
        open={openTagModal}
        onConfirm={onAssignConfirm({ mutation, params, queryClient })}
      />
      {isMobile && <ScrollToTop elementRef={viewportRef} />}
    </Container>
  );
};
